import { businessFromPath, businessLabels, taskBasePath, type TaskBusiness } from "./business";

export const taskNavigation = [
  { key: "all", label: "全部任务", href: "/tasks" },
  { key: "new", label: "新建任务", href: "/tasks/new" },
];
export function businessNavigation(business: TaskBusiness) {
  return [
    { path: `${taskBasePath(business)}/new`, key: `${business}-new`, name: business === "sms" ? "新建 iMessage 任务" : "新建推广任务" },
    { path: taskBasePath(business), key: `${business}-tasks`, name: business === "sms" ? "iMessage 任务" : "推广任务" },
    { path: `/${business}/submissions`, key: `${business}-submissions`, name: "任务领取记录" },
    { path: `/${business}/reports`, key: `${business}-reports`, name: "数据报表" },
    ...(business === "promotion" ? [{ path: "/promotion/materials", key: "promotion-materials", name: "素材管理" }] : []),
  ];
}
export function selectedNavigation(pathname: string, _search: string) {
  const business = businessFromPath(pathname);
  if (business === "advertising") return pathname === "/advertising/new" ? "advertising-new" : pathname.startsWith("/advertising/materials") ? "advertising-materials" : pathname.startsWith("/advertising/reports") ? "advertising-reports" : "advertising-list";
  if (business) {
    if (pathname === `${taskBasePath(business)}/new`) return `${business}-new`;
    if (pathname.startsWith(taskBasePath(business))) return `${business}-tasks`;
    return `${business}-${pathname.split("/")[2] || "tasks"}`;
  }
  if (pathname === "/tasks/new") return "task-new";
  if (pathname.startsWith("/tasks")) return "task-all";
  if (pathname.startsWith("/help") || pathname.startsWith("/feedback")) return "/help";
  return ["/finance", "/submissions", "/reports", "/materials", "/notifications", "/account"].find((p) => pathname.startsWith(p)) || "/";
}

export function pageTab(pathname: string, search = "", hash = "") {
  const names: Record<string, string> = {
    "/finance": "资金与结算",
    "/": "首页", "/tasks/new": "新建任务", "/submissions": "任务领取记录",
    "/reports": "数据报表", "/advertising": "我的广告", "/advertising/new": "新建广告", "/advertising/reports": "广告报表",
    "/advertising/materials": "广告素材",
    "/materials": "素材管理", "/notifications": "消息中心", "/account": "账号与安全",
    "/help": "帮助与反馈", "/help/feedback": "我的反馈", "/help/feedback/new": "提交反馈",
  };
  const path = pathname.replace(/\/+$/, "") || "/";
  let key = path;
  let label = names[path];
  const business = businessFromPath(path);
  if (business && business !== "advertising") {
    const suffix = path.slice(business.length + 1);
    const titles: Record<string, string> = { "/tasks": "任务列表", "/tasks/new": "新建任务", "/submissions": "任务领取记录", "/reports": "数据报表", "/materials": "素材管理" };
    const task = suffix.match(/^\/tasks\/([^/]+)(\/edit)?$/);
    label = `${businessLabels[business]} · ${titles[suffix] || (task ? `${task[2] ? "编辑" : "详情"} #${task[1]}` : "")}`;
    if (!titles[suffix] && !task) return null;
  } else if (path === "/tasks") {
    key = "/tasks:all";
    label = "全部任务";
  } else {
    const task = path.match(/^\/tasks\/([^/]+)(\/edit)?$/);
    const feedback = path.match(/^\/(?:help\/)?feedback\/([^/]+)$/);
    if (!label && task) label = `${task[2] ? "编辑任务" : "任务详情"} · ${task[1]}`;
    if (!label && feedback && feedback[1] !== "new") label = `反馈详情 · ${feedback[1]}`;
  }
  return label ? { key, label, href: `${path}${search}${hash}` } : null;
}
